import React, { useMemo } from 'react';
import { TestWidget } from './index';
import { NonIdealState } from '@blueprintjs/core';

import { widgetConfigurationProps, dimensionsProps } from "./interfaces"; 
import { NO_DATA_MESSAGE } from 'widgets/chartUtils';

/**
 * ChartWrapper for the Test Widget.
 *
 * FIXME: Currently does that thing where it won't allow the parent to shrink.
 *
 * @param widgetConfiguration
 * @param dimensions
 * @param data
 * @param noDataMessage
 * @returns {*}
 * @constructor
 */
export const TestWidgetWrapper: React.FC<TestWidgetWrapperProps> = ({
	widgetConfiguration = { backgroundColor: 'dodgerblue', title: 'Test' },
	dimensions,
	data,
	noDataMessage=NO_DATA_MESSAGE,
}) => {
	const convertedData = useMemo(() => {
		return data?.entries?.map(value => value.value);
	}, [data]);

	if (!("backgroundColor" in Object.keys(widgetConfiguration))) {
		widgetConfiguration.backgroundColor = 'dodgerblue';
	}

	//If the state is not ideal (the data is null or empty) render the nonIdealState message
	return (convertedData && Object.keys(convertedData).length > 0) ? (
		<TestWidget
			data={convertedData}
			dimensions={dimensions}
			backgroundColor={widgetConfiguration.backgroundColor}
			title={widgetConfiguration.title}
		/>
	) : (
		<NonIdealState
			title="No Data Found"
			icon="graph-remove"
			description={noDataMessage}
		/>
	);
}

interface TestWidgetWrapperProps {
	data: {
		fullSize: number,
		count: number,
		entries: {
			key: string,
			count: number,
			value: number,
			children: {
				key: string,
				count: number,
				value: number
			}[]
		}[],
		keys: string[][],
		pageSize: number,
		value: number
	},
	widgetConfiguration: widgetConfigurationProps,
	dimensions: dimensionsProps,
	noDataMessage: string,
}